import { Navigate } from "react-router-dom";

import { connect } from "react-redux";

import { useLocation } from "react-router-dom";
function PrivateRoute(props) {
  const { children, loginAllowed } = props;

  const state = useLocation();

  return true ? (
    children
  ) : (
    <Navigate state={{ from: state.pathname }} replace to="/login" />
  );
}

const mapStateToProps = () => {
  // console.log(state)
  // return state;
};

export default connect(mapStateToProps)(PrivateRoute);
